export const foglalkozasData = [
  {
    "date": "2025-12-16",
    "title": "Foglalkozás",
    "mainimage": "../images/bastya/2025.12.16- foglalkozas/1.jpg",
    "images":
    {
      "image1": "../images/bastya/2025.12.16- foglalkozas/1.jpg",
      "image2": "../images/bastya/2025.12.16- foglalkozas/2.jpg",
      "image3": "../images/bastya/2025.12.16- foglalkozas/3.jpg",
      "image4": "../images/bastya/2025.12.16- foglalkozas/4.jpg",
      "image5": "../images/bastya/2025.12.16- foglalkozas/5.jpg",
      "image6": "../images/bastya/2025.12.16- foglalkozas/6.jpg",
      "image7": "../images/bastya/2025.12.16- foglalkozas/7.jpg",
      "image8": "../images/bastya/2025.12.16- foglalkozas/8.jpg",
      "image9": "../images/bastya/2025.12.16- foglalkozas/9.jpg",
      "image10": "../images/bastya/2025.12.16- foglalkozas/10.jpg",
      "image11": "../images/bastya/2025.12.16- foglalkozas/11.jpg",
      "image12": "../images/bastya/2025.12.16- foglalkozas/12.jpg",
      "image13": "../images/bastya/2025.12.16- foglalkozas/13.jpg",
    }

  },
  {
    "date": "2025-12-17",
    "title": "Foglalkozás",
    "mainimage": "../images/bastya/2025.12.17-foglalkozas/1.jpg",
    "images":
    {
      "image1": "../images/bastya/2025.12.17-foglalkozas/1.jpg",
      "image2": "../images/bastya/2025.12.17-foglalkozas/2.jpg",
      "image3": "../images/bastya/2025.12.17-foglalkozas/3.jpg",
      "image4": "../images/bastya/2025.12.17-foglalkozas/4.jpg",
      "image5": "../images/bastya/2025.12.17-foglalkozas/5.jpg",
      "image6": "../images/bastya/2025.12.17-foglalkozas/6.jpg",
      "image7": "../images/bastya/2025.12.17-foglalkozas/7.jpg",
      "image8": "../images/bastya/2025.12.17-foglalkozas/8.jpg",
      "image9": "../images/bastya/2025.12.17-foglalkozas/9.jpg",
      "image10": "../images/bastya/2025.12.17-foglalkozas/10.jpg",
      "image11": "../images/bastya/2025.12.17-foglalkozas/11.jpg",
      "image12": "../images/bastya/2025.12.17-foglalkozas/12.jpg",
      "image13": "../images/bastya/2025.12.17-foglalkozas/13.jpg",
    }
  },
  {
    "date": "2026-01-10",
    "title": "Ügyességi",
    "mainimage": "../images/bastya/2026.01.10-ugyessegi/1.jpg",
    "images":
    {
      "image1": "../images/bastya/2026.01.10-ugyessegi/1.jpg",
      "image2": "../images/bastya/2026.01.10-ugyessegi/2.jpg",
      "image3": "../images/bastya/2026.01.10-ugyessegi/3.jpg",
      "image4": "../images/bastya/2026.01.10-ugyessegi/4.jpg",
      "image5": "../images/bastya/2026.01.10-ugyessegi/5.jpg",
      "image6": "../images/bastya/2026.01.10-ugyessegi/6.jpg",
      "image7": "../images/bastya/2026.01.10-ugyessegi/7.jpg",
      "image8": "../images/bastya/2026.01.10-ugyessegi/8.jpg"
    }
  },
   {
    "date": "2026-01-10",
    "title": "Kézművesség",
    "mainimage": "../images/bastya/2026.01.15-kezmuvesseg/1.jpg",
    "images":
    {
      "image1": "../images/bastya/2026.01.15-kezmuvesseg/1.jpg",
      "image2": "../images/bastya/2026.01.15-kezmuvesseg/2.jpg",
      "image3": "../images/bastya/2026.01.15-kezmuvesseg/3.jpg",
      "image4": "../images/bastya/2026.01.15-kezmuvesseg/4.jpg",
      "image5": "../images/bastya/2026.01.15-kezmuvesseg/5.jpg",
      "image6": "../images/bastya/2026.01.15-kezmuvesseg/6.jpg",
      "image7": "../images/bastya/2026.01.15-kezmuvesseg/7.jpg",
      "image8": "../images/bastya/2026.01.15-kezmuvesseg/8.jpg",
      "image9": "../images/bastya/2026.01.15-kezmuvesseg/9.jpg",
    }
  },
   {
    "date": "2026-01-16",
    "title": "Játék",
    "mainimage": "../images/bastya/2026.01.16-jatek/1.jpg",
    "images":
    {
      "image1": "../images/bastya/2026.01.16-jatek/1.jpg",
      "image2": "../images/bastya/2026.01.16-jatek/2.jpg",
      "image3": "../images/bastya/2026.01.16-jatek/3.jpg",
      "image4": "../images/bastya/2026.01.16-jatek/4.jpg",
      "image5": "../images/bastya/2026.01.16-jatek/5.jpg",
      "image6": "../images/bastya/2026.01.16-jatek/6.jpg",
      "image7": "../images/bastya/2026.01.16-jatek/7.jpg",
      "image8": "../images/bastya/2026.01.16-jatek/8.jpg",
      "image9": "../images/bastya/2026.01.16-jatek/9.jpg",
      "image10": "../images/bastya/2026.01.16-jatek/10.jpg",
      "image11": "../images/bastya/2026.01.16-jatek/11.jpg",
      "image12": "../images/bastya/2026.01.16-jatek/12.jpg",
      "image13": "../images/bastya/2026.01.16-jatek/13.jpg",
    }
  },
  {
    "date": "2026-01-16",
    "title": "Gyógytorna",
    "mainimage": "../images/bastya/gyogytorna/1.jpeg",
    "images":
    {
      "image1": "../images/bastya/gyogytorna/1.jpeg",
      "image2": "../images/bastya/gyogytorna/2.jpeg",
      "image3": "../images/bastya/gyogytorna/3.jpeg",
      "image4": "../images/bastya/gyogytorna/4.jpeg",
      "image5": "../images/bastya/gyogytorna/5.jpeg",
    }
  },
];